import { createFileRoute } from "@tanstack/react-router"
import { FinanceInvoicesPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/finance/invoices/"
)({
  component: () => (
    <AuthorizationGate resource={Resource.INVOICE} action={Action.READ}>
      <FinanceInvoicesPage />
    </AuthorizationGate>
  ),
})
